import {
  AfterViewInit,
  Component,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DownloadFileService } from 'src/app/modules/map/services/Download-File/download-file.service';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { SideNavService } from 'src/app/modules/map/services/sidenav/side-nav.service';
import { LoaderComponent } from 'src/app/modules/shared/components/loader/loader.component';

@Component({
  selector: 'app-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: [
    '../view-and-export-data.component.css',
    './map-view.component.css',
  ],
})
export class MapViewComponent implements OnInit, AfterViewInit {
  value: any;
  showBtn: any;
  xmin: any;
  xmax: any;
  ymin: any;
  ymax: any;
  enabled_overlay: any[] = [];
  overlayLayer: any;
  multipleParcel = false;
  zoom: any;
  buffers = '';
  buffersInner = '';
  shareUrl: any;
  showAnnotations = [
    2, 323, 954, 87, 149, 150, 264, 322, 401, 403, 408, 185, 31, 486, 968, 970,
    971, 975, 972, 973, 981, 984, 974, 1024, 1025, 1026, 1033,
  ];
  selectedPoint = '';
  innerWidth: any;
  innerHeight: any;
  embedEode = false;
  tcpdEmbed = false;
  basicMode = false;
  dataPanelHide = true;
  mapName = 'google-hybrid';
  mapId: any;
  requireCheckbox = false;
  parcelLabel = '';
  shereLinkData: any;
  userAccessLevel: any;
  title: any;
  titleFile: any;
  fileName: any;
  isPdf = true;
  isEmbed = false;
  checkboxTemplate = '';
  boundaries: any;
  RequireCheckBox = false;
  defaultModal = false;
  template = '';
  show: any;
  layerFeatures: any;
  url: any;
  url1: any;
  minZoom: any = '0';
  isGeolock: any;
  parcelId: any;
  downloadurl: any;
  @ViewChild(LoaderComponent, { static: false }) loader!: LoaderComponent;
  constructor(
    private mapService: MapServiceService,
    private router: Router,
    public downloadFileService: DownloadFileService,
    private sideNavService: SideNavService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    this.boundaries = this.mapService.mapData.map_data.map_data.layers;
    this.layerFeatures = this.mapService.featureLayerId;
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
    if (!this.mapService.baseLayerName) {
      this.mapService.baseLayerName = this.mapName;
    } else {
      this.mapService.baseLayerName;
    }
    this.zoom =
      this.mapService.mapLayer.getView().getZoom() -
      this.mapService.mapsData.minzoom;

    this.route.queryParamMap.subscribe((params) => {
      setTimeout(() => {
        this.downloadFileService.shareUrlId = params.get('share');
      }, 1000);
    });
    const originUrl = location.origin;
    const href: any = this.router.url.split('?').shift();
    this.shareUrl = originUrl.concat(href);
    // console.log(this.shareUrl);
    this.userAccessLevel = this.mapService.mapAccessLevel;
    this.dataPanelHide = true;
    this.isEmbed = false;

    for (let i = 0; i < this.boundaries.length; i++) {
      if (
        this.boundaries[i].name === 'Parcels' ||
        this.boundaries[i].name.toLowerCase().includes('parcels')
      ) {
        this.parcelId = this.boundaries[i]?.id.toString();
        break;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
  }

  public ngAfterViewInit() {
    this.createFile();
  }

  createFile(): void {
    const bounds = this.mapService.mapLayer
      .getView()
      .calculateExtent(this.mapService.mapLayer.getSize());
    for (let i = 0; i < bounds.length; i++) {
      if (i == 0) {
        this.xmin = bounds[i];
      } else if (i == 1) {
        this.xmax = bounds[i];
      } else if (i == 2) {
        this.ymin = bounds[i];
      } else if (i == 3) {
        this.ymax = bounds[i];
      }
    }
    this.overlayLayer = this.mapService.getLayersId();
    if (!this.mapService.polygonGeometry) {
      this.mapService.polygonGeometry = '';
    }
    if (!this.mapService.pointGeometry) {
      this.mapService.pointGeometry = '';
    }
    if (!this.mapService.parcel) {
      this.mapService.parcel = '0';
    }
    if (!this.overlayLayer) {
      this.overlayLayer = '';
    }
    if (!this.mapService.featureLayerId) {
      this.mapService.featureLayerId = '0';
    }
    if (this.mapService.multiParcelId.length > 1) {
      this.mapService.multiParcel = true;
    } else {
      this.mapService.multiParcel = false;
    }
    if (!this.title) {
      this.title = '';
    }
    this.isPdf = false;
    if (!this.fileName) {
      this.fileName = '';
    }
    if (!this.downloadFileService.shareUrlId) {
      this.downloadFileService.shareUrlId = '';
    }
    if (!this.mapService.innerBuffer) {
      this.mapService.innerBuffer = '';
    }
    if (this.sideNavService.checkLabel) {
      this.parcelLabel = this.mapService.parcel;
    }
    this.mapService.innerBuffer = this.mapService.innerBuffer.filter((value: any) => value !== null && typeof value !== "undefined");

    // this.showBtn = true; //testing purpost
    const body = {
      xmin_bound: this.xmin.toString(),
      xmax_bound: this.xmax.toString(),
      ymin_bound: this.ymin.toString(),
      ymax_bound: this.ymax.toString(),
      width: this.innerWidth,
      height: this.innerHeight,
      zoom: this.zoom.toString(),
      parcel: this.mapService.parcel,
      overlay: this.overlayLayer.toString(),
      base_layer: this.mapService.shareCurrentMap,
      feature_layer: this.mapService.featureLayerId,
      point: this.mapService.pointGeometry,
      wkt: this.mapService.polygonGeometry,
      multiple_parcel: this.mapService.multiParcel,
      expiry_time: '0',
      expire: false,
      buffers: this.mapService.bufferPolygonGeometry,
      buffers_inner: this.mapService.innerBuffer,
      show_annotations: this.mapService.annotationShare.toString() || '',
      selected_point: this.mapService.preSelectedAnnotation || '',
      basic_mode: this.basicMode,
      tcpd_embed: this.tcpdEmbed,
      require_checkbox: this.requireCheckbox,
      checkbox_template: this.checkboxTemplate,
      chosen_privilege_level: +this.userAccessLevel,
      show_legend: false,
      default_modal: this.defaultModal,
      template: this.template,
      parcel_label: this.parcelLabel,
      data_panel_hide: this.dataPanelHide,
      share_url: this.shareUrl,
      is_embed: this.isEmbed,
      print_title: this.title,
      is_pdf: this.isPdf,
      minzoom: +this.minZoom,
      is_geolock: (this.isGeolock = false),
    };
    this.loader.toggleSpinner(true);
    this.downloadFileService
      .downloadView(this.mapId, this.downloadFileService.shareUrlId, body)
      .subscribe((res: any) => {
        if (res) {
          this.show = true;
          this.url = `${this.sideNavService.downloadFileUrl}/media/downloaded_reports/${res.file_name}`;
          this.loader.toggleSpinner(false);
          this.showBtn = true;
        }
      });
  }

  pdf(): void {
    let layerId: any;
    let layerName: any;
    let arr = [];
    if (this.layerFeatures.length) {
      for (let i = 0; i < this.layerFeatures.length; i++) {
        if (this.parcelId == this.layerFeatures[i].layer_id) {
          arr.push(this.layerFeatures[i].id);
          layerId = this.layerFeatures[i].layer_id;
        }
      }
    } else {
      if (this.parcelId == this.layerFeatures.layer_id) {
        arr = this.layerFeatures.id;
        layerId = this.layerFeatures.layer_id;
      }
    }
    this.boundaries = this.mapService.mapData.map_data.map_data.layers;
    for (let i = 0; i < this.boundaries.length; i++) {
      if (this.boundaries[i].id.toString() == layerId) {
        layerName = this.boundaries[i].name;
        break;
      }
    }
    if (this.parcelId && layerId && arr.length != 0) {
      this.mapService
        .getPdfDataField(layerId.toString(), this.mapId, arr.toString())
        .subscribe((res: any) => {
          this.show = true;
          if (res) {
            const body = {
              download_type: 'pdf_table',
              show_apn: true,
              use_mail_address: false,
              use_situs_address: false,
              skip_duplicates: false,
              table_name: ' ',
              layer_name: layerName.toString(),
              map_name: this.mapService.mapData.map_data.map_data.name,
              features: res.results[0],
            };
            this.mapService.dataView(body).subscribe((res: any) => {
              this.url1 = `${this.sideNavService.downloadFileUrl}/${res.file_path}`;
              const element1: any = document.getElementById('submit-pdf1');
              element1.href = this.url1;
              element1.target = '_blank';
              element1.click();
              element1.href = '';
            });
          }
        });
    }

    this.createFilePdf();
  }

  createFilePdf(): void {
    const bounds = this.mapService.mapLayer
      .getView()
      .calculateExtent(this.mapService.mapLayer.getSize());
    for (let i = 0; i < bounds.length; i++) {
      if (i == 0) {
        this.xmin = bounds[i];
      } else if (i == 1) {
        this.xmax = bounds[i];
      } else if (i == 2) {
        this.ymin = bounds[i];
      } else if (i == 3) {
        this.ymax = bounds[i];
      }
    }
    this.overlayLayer = this.mapService.getLayersId();
    if (!this.mapService.polygonGeometry) {
      this.mapService.polygonGeometry = '';
    }
    if (!this.mapService.pointGeometry) {
      this.mapService.pointGeometry = '';
    }
    if (!this.mapService.parcel) {
      this.mapService.parcel = '0';
    }

    if (!this.mapService.featureLayerId) {
      this.mapService.featureLayerId = '0';
    }
    if (this.mapService.multiParcelId.length > 1) {
      this.mapService.multiParcel = true;
    } else {
      this.mapService.multiParcel = false;
    }
    if (!this.title) {
      this.title = '';
    }
    this.isPdf = true;
    if (!this.fileName) {
      this.fileName = '';
    }
    if (!this.downloadFileService.shareUrlId) {
      this.downloadFileService.shareUrlId = '';
    }
    if (!this.mapService.innerBuffer) {
      this.mapService.innerBuffer = '';
    }
    if (this.sideNavService.checkLabel) {
      this.parcelLabel = this.mapService.parcel;
    }
    const body = {
      xmin_bound: this.xmin.toString(),
      xmax_bound: this.xmax.toString(),
      ymin_bound: this.ymin.toString(),
      ymax_bound: this.ymax.toString(),
      width: this.innerWidth,
      height: this.innerHeight,
      zoom: this.zoom.toString(),
      parcel: this.mapService.parcel,
      overlay: this.overlayLayer.toString(),
      base_layer: this.mapService.shareCurrentMap,
      feature_layer: this.mapService.featureLayerId,
      point: this.mapService.pointGeometry,
      wkt: this.mapService.polygonGeometry,
      multiple_parcel: this.mapService.multiParcel,
      expiry_time: '0',
      expire: false,
      buffers: this.mapService.polygonGeometry,
      buffers_inner: this.mapService.innerBuffer,
      show_annotations: this.mapService.annotationShare.toString()||'',
      selected_point: this.mapService.preSelectedAnnotation||'',
      basic_mode: this.basicMode,
      tcpd_embed: this.tcpdEmbed,
      require_checkbox: this.requireCheckbox,
      checkbox_template: this.checkboxTemplate,
      chosen_privilege_level: +this.userAccessLevel,
      show_legend: false,
      default_modal: this.defaultModal,
      template: this.template,
      parcel_label: this.parcelLabel,
      data_panel_hide: this.dataPanelHide,
      share_url: this.shareUrl,
      is_embed: this.isEmbed,
      print_title: this.title,
      is_pdf: this.isPdf,
      minzoom: +this.minZoom,
      is_geolock: (this.isGeolock = false),
    };
    this.downloadFileService
      .downloadView(this.mapId, this.downloadFileService.shareUrlId, body)
      .subscribe((res: any) => {
        if (res) {
          this.show = true;
          this.downloadurl = `${this.sideNavService.downloadFileUrl}/media/downloaded_reports/${res.file_name}`;
          this.showBtn = true;
          const element1: any = document.getElementById('submit-pdf2');
          element1.href = this.downloadurl;
          element1.target = '_blank';
          element1.click();
          this.loader.toggleSpinner(false);
          element1.href = '';
        }
      });
  }
}
